import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ScrollArea } from "@mantine/core";
import { SourceConfigFooter } from "./SourceConfigFooter.js";
import { SourceConfigHeader } from "./SourceConfigHeader.js";
import { SecondaryPanel } from "../../components/SidePanel.js";
export const SourceConfigData = ({ sourceId }) => {
    return (_jsxs(SecondaryPanel, { children: [_jsx(SourceConfigHeader, { sourceId: sourceId }), _jsx(ScrollArea, { flex: "1", mih: 0 }), _jsx(SourceConfigFooter, {})] }));
};
